/* ─────────────────────────────────────────
   KUNDA — Firebase initialization
   Single source of truth for Firebase app instances.
   Imported by App.js and longterm.js (and future modules).
───────────────────────────────────────── */
import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";
import { getStorage } from "firebase/storage";
import { getAuth, setPersistence, browserLocalPersistence } from "firebase/auth";

var firebaseConfig = {
  apiKey:            "AIzaSyDVRXtS3MnvIjUlWZ1NcC-OJs1Aucvgg-A",
  authDomain:        "kunda-c8630.firebaseapp.com",
  databaseURL:       "https://kunda-c8630-default-rtdb.europe-west1.firebaseio.com",
  projectId:         "kunda-c8630",
  storageBucket:     "kunda-c8630.firebasestorage.app",
  messagingSenderId: "246158333118",
  appId:             "1:246158333118:web:a536b4b4b86947964f7aef",
  measurementId:     "G-L5SHJMR3CG",
};

var firebaseApp = initializeApp(firebaseConfig);

export var db      = getFirestore(firebaseApp);
export var storage = getStorage(firebaseApp);
export var auth    = getAuth(firebaseApp);

/* Explicitly persist the session in localStorage so a signed-in host stays
   signed in across refreshes and tabs. This is Firebase's default, but making
   it explicit removes any doubt when a session appears to vanish. */
setPersistence(auth, browserLocalPersistence).catch(function(e) {
  console.error("Auth persistence could not be set:", e && e.code);
});
